'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _containers = require('../../containers');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PERMISSIONS = _constants.AppConstants.PERMISSIONS;
var DeleteLienButton = (_temp = _class = function (_Component) {
  _inherits(DeleteLienButton, _Component);

  function DeleteLienButton() {
    _classCallCheck(this, DeleteLienButton);

    return _possibleConstructorReturn(this, (DeleteLienButton.__proto__ || Object.getPrototypeOf(DeleteLienButton)).apply(this, arguments));
  }

  _createClass(DeleteLienButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Button2.default,
        _extends({
          bsSize: 'small',
          bsStyle: 'danger'
        }, this.props),
        'Delete'
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DeleteLienButton;
}(_react.Component), _class.propTypes = {
  onClick: _propTypes2.default.func
}, _temp);


var GuardedDeleteLienButton = (0, _containers.createGuardedContainer)({
  disabledComponent: (0, _containers.createDisabledContainer)(DeleteLienButton),
  enabledComponent: DeleteLienButton,
  permissionName: PERMISSIONS.DELETE_LIEN
});

var _default = GuardedDeleteLienButton;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case/DeleteLienButton.js');
  reactHotLoader.register(DeleteLienButton, 'DeleteLienButton', '/app/src/components/page-case/DeleteLienButton.js');
  reactHotLoader.register(GuardedDeleteLienButton, 'GuardedDeleteLienButton', '/app/src/components/page-case/DeleteLienButton.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/DeleteLienButton.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9EZWxldGVMaWVuQnV0dG9uLmpzIl0sIm5hbWVzIjpbIlBFUk1JU1NJT05TIiwiQXBwQ29uc3RhbnRzIiwiRGVsZXRlTGllbkJ1dHRvbiIsInByb3BzIiwiQ29tcG9uZW50IiwicHJvcFR5cGVzIiwib25DbGljayIsIlByb3BUeXBlcyIsImZ1bmMiLCJHdWFyZGVkRGVsZXRlTGllbkJ1dHRvbiIsImRpc2FibGVkQ29tcG9uZW50IiwiZW5hYmxlZENvbXBvbmVudCIsInBlcm1pc3Npb25OYW1lIiwiREVMRVRFX0xJRU4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7Ozs7O0FBSUE7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFUUEsVyxHQUFnQkMsdUIsQ0FBaEJELFc7SUFFRkUsZ0I7Ozs7Ozs7Ozs7OzZCQUNNO0FBQ1IsYUFDRTtBQUFDLHdCQUFEO0FBQUE7QUFDRSxrQkFBTyxPQURUO0FBRUUsbUJBQVE7QUFGVixXQUdNLEtBQUtDLEtBSFg7QUFBQTtBQUFBLE9BREY7QUFTRDs7Ozs7Ozs7Ozs7RUFYNEJDLGdCLFVBYXRCQyxTLEdBQVk7QUFDakJDLFdBQVNDLG9CQUFVQztBQURGLEM7OztBQUtyQixJQUFNQywwQkFBMEIsd0NBQXVCO0FBQ3JEQyxxQkFBbUIseUNBQXdCUixnQkFBeEIsQ0FEa0M7QUFFckRTLG9CQUFrQlQsZ0JBRm1DO0FBR3JEVSxrQkFBZ0JaLFlBQVlhO0FBSHlCLENBQXZCLENBQWhDOztlQU1lSix1Qjs7Ozs7Ozs7Ozs7MEJBMUJQVCxXOzBCQUVGRSxnQjswQkFrQkFPLHVCIiwiZmlsZSI6IkRlbGV0ZUxpZW5CdXR0b24uanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5pbXBvcnQgeyBCdXR0b24gfSBmcm9tICdyZWFjdC1ib290c3RyYXAnO1xuXG5pbXBvcnQgeyBjcmVhdGVHdWFyZGVkQ29udGFpbmVyLCBjcmVhdGVEaXNhYmxlZENvbnRhaW5lciB9IGZyb20gJy4uLy4uL2NvbnRhaW5lcnMnO1xuaW1wb3J0IHsgQXBwQ29uc3RhbnRzIH0gZnJvbSAnLi4vLi4vY29uc3RhbnRzJztcblxuY29uc3QgeyBQRVJNSVNTSU9OUyB9ID0gQXBwQ29uc3RhbnRzO1xuXG5jbGFzcyBEZWxldGVMaWVuQnV0dG9uIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgcmVuZGVyICgpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPEJ1dHRvblxuICAgICAgICBic1NpemU9J3NtYWxsJ1xuICAgICAgICBic1N0eWxlPSdkYW5nZXInXG4gICAgICAgIHsuLi50aGlzLnByb3BzfVxuICAgICAgPlxuICAgICAgICBEZWxldGVcbiAgICAgIDwvQnV0dG9uPlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIG9uQ2xpY2s6IFByb3BUeXBlcy5mdW5jLFxuICB9XG59XG5cbmNvbnN0IEd1YXJkZWREZWxldGVMaWVuQnV0dG9uID0gY3JlYXRlR3VhcmRlZENvbnRhaW5lcih7XG4gIGRpc2FibGVkQ29tcG9uZW50OiBjcmVhdGVEaXNhYmxlZENvbnRhaW5lcihEZWxldGVMaWVuQnV0dG9uKSxcbiAgZW5hYmxlZENvbXBvbmVudDogRGVsZXRlTGllbkJ1dHRvbixcbiAgcGVybWlzc2lvbk5hbWU6IFBFUk1JU1NJT05TLkRFTEVURV9MSUVOLFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IEd1YXJkZWREZWxldGVMaWVuQnV0dG9uO1xuIl19